<form (ngSubmit)="login()">
  <div *ngIf="showForgotPasswordForm">
    <div *ngIf="emailSended">
      <span class="size-4"> {{ emailSendedText }}</span>
      <div class="text-sm justify-center items-center mt-5 underline text-blue-600 cursor-pointer">
        <span (click)="showLoginView()"> {{ backToLoginText }}</span>
      </div>
    </div>
    <div *ngIf="!emailSended">
      <dx-text-box
        [label]="'common.email' | translate | ucfirst"
        [(value)]="email"
      ></dx-text-box>
      <dx-button [text]="'common.send' | translate" style="color: white;"
          class="mt-3"
          type="default"
          (click)="forgotPassword()"
      ></dx-button>
      <div class="text-sm justify-center items-center mt-5 underline text-blue-600 cursor-pointer">
        <span (click)="showLoginView()"> {{ backToLoginText }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="!showForgotPasswordForm" class="flex flex-col">
    <div class="">
      <img class="w-80 mt-5" [src]="loginLogo">
    </div>
    <div class="mt-10">
      <dx-text-box
        [label]="'common.userName' | translate | ucfirst"
        [(value)]="userName"
        [elementAttr]="{ id: 'login-username' }"
      ></dx-text-box>
      <dx-text-box
        value="password"
        [label]="'common.password' | translate | ucfirst"
        [(value)]="password"
        [(mode)]="passwordMode"
        [elementAttr]="{ id: 'login-password' }"
      >
        <dxi-button
          name="today"
          location="after"
          [options]="passwordButton"
        ></dxi-button>
      </dx-text-box>
      <p class="text-sm text-left" style="color:red; font-size: 12px;">{{passwordError}}</p>
    </div>
    <div id="capsLockWarning" *ngIf="capsLock">
      <p>{{capsLockMessage}}</p>
    </div>
    <div class="content-center mt-10 mb-3">
      <div class="items-center justify-center">
        <dx-button [text]="'common.logIn' | translate" style="color: white;"
          class="mt-3"
          type="default"
          [useSubmitBehavior]="true"
          [style.background-color]="backgroundLoginButtonColor"
          [elementAttr]="{ id: 'login-submit-button' }"
        ></dx-button>
      </div>
      <div class="text-sm justify-center items-center mt-5 underline text-blue-600 cursor-pointer">
        <span (click)="showForgotPasswordView()"> {{ forgotPasswordText }}</span>
      </div>
    </div>
  </div>
</form>
